/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMini,
    AssetMiniFromJSON,
    AssetMiniFromJSONTyped,
    AssetMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface LocateProxiesEndpointResponse
 */
export interface LocateProxiesEndpointResponse {
    /**
     * 
     * @type {AssetMini}
     * @memberof LocateProxiesEndpointResponse
     */
    asset: AssetMini;
    /**
     * 
     * @type {string}
     * @memberof LocateProxiesEndpointResponse
     */
    syncId: string;
    /**
     * 
     * @type {string}
     * @memberof LocateProxiesEndpointResponse
     */
    path: string;
}

export function LocateProxiesEndpointResponseFromJSON(json: any): LocateProxiesEndpointResponse {
    return LocateProxiesEndpointResponseFromJSONTyped(json, false);
}

export function LocateProxiesEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocateProxiesEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': AssetMiniFromJSON(json['asset']),
        'syncId': json['sync_id'],
        'path': json['path'],
    };
}

export function LocateProxiesEndpointResponseToJSON(value?: LocateProxiesEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': AssetMiniToJSON(value.asset),
        'sync_id': value.syncId,
        'path': value.path,
    };
}


